<div class="container-fluid text-center vhLogin position-relative imgfond" style="height: 100vh;">
   
  
    <div class="bg-white shadow-sm box_login position-absolute top-50 start-50 translate-middle " >
        <div class="row">
            <div class="col-12 col-md-6 padding23">
                <div class="row mb-2">
                    <div class="col-7 mx-auto">
                        <img src="assets/img/logo/ECODELI PARTNER OK.png" class="w-100" alt="">
                    </div>
                   </div>
                  
                    
                    <form action="">
                    <div class="row justify-content-center">
                        <div class="col-10 my-3">
                            <mat-form-field appearance="outline" class="w100 bgwhite rounded" >
                                <mat-label>Usuario</mat-label>
                                <input matInput type="text" #inputUser  [(ngModel)]="strUsuario" class="" autocomplete="current-username" >
                            </mat-form-field>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-center">
                     
            
            
                        <div class="col-10">
                            <div class="example-container">
                               
                                <mat-form-field appearance="outline" class="w100 bgwhite rounded">
                                    <mat-label>Contraseña</mat-label>
                                    <input matInput [type]="hide ? 'password' : 'text'" [(ngModel)]="strPass" class="inputL" autocomplete="current-password" >          
                                    <i  class="fs-4 pointer bi " matSuffix (click)="hide = !hide" [ngClass]="{'bi-eye-fill': hide,'bi-eye-slash-fill':!hide}"></i>       
                                </mat-form-field>
                            
                            </div>
                        </div>
                    
                    </div>
                    </form>
                    <br>
                    <div class="row">
                        <div class="col-12 my-3">
                            <button (click)="fnGetEncriptado()" [disabled]="strUsuario=='' || strPass==''"class="btn btnIngresar rounded-pill shadow-sm" >Iniciar Sesión</button><!-- [disabled]="selectEmpresa=='' || strUsuario=='' || strPass==''" -->
                        </div>
                        <!-- <div class="col-12 my-3">
                            <span>
                                Conviértete en Partner y gana más haz <a [routerLink]="['/partner-register']">click aquí</a> 
                            </span>
                        </div> -->
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class=" w-100 mt-2 text-center "  >Conviértete en Partner y gana más <a [routerLink]="['/partner-register']" class="fw-bold">haz click aquí</a></div>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-12 mx-auto d-none d-md-flex">
                    <img src="assets/img/logo/ban3.jpg"  class="w-100 h-100" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
